module.exports = __webpack_public_path__ + "static/img/zncz.9c8f9ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zncz.png
// module id = 4or5
// module chunks = 0